import * as React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Types
import { ruleEditorViewPartCommonProps } from '../../types';

const PlainRenderContainer = styled.div`
    ${'' /* flex-grow: 1; */}
    white-space: nowrap;
    display: flex;
    align-items: center;
    z-index: 1;
`;

function getResourceLabel(criteriaResource) {
    var result;
    var paramList = [];
    if (criteriaResource) {
        var criteriaResourceParams = criteriaResource.criteriaResourceParams ?? null;
        var resourceType = criteriaResource.resourceType ?? null;
        if (criteriaResourceParams) {
            for (var i = 0; i < criteriaResourceParams.length; i++) {
                var param = criteriaResourceParams[i];
                paramList.push(param.name);
            }
        }
        if (resourceType === 'Function') {
            result = criteriaResource.name + '(';
        } else if (resourceType === 'Global') {
            result = 'global: ' + criteriaResource.name;
        } else if (resourceType === 'Operator') {
            result = 'operator: (' + paramList.join(', ') + ')';
        } else {
            result = 'criteria resource type unhandled!';
        }
    } else {
        result = 'criteriaResource empty!';
    }
    return result;
}

function getConcatenatedConceptSelection(part, type) {
    var concatenatedList = '';
    var comma = ', ';
    var counter = 1;
    var predicatePartConcepts = part.predicatePartConcepts ?? null;
    var conceptSelectionType = part.conceptSelectionType ?? null;
    for (var i = 0; i < predicatePartConcepts.length; i++) {
        var predicatePartConceptDTO = predicatePartConcepts[i];
        if (predicatePartConcepts.length === counter) {
            comma = '';
        }

        var concept;
        if (conceptSelectionType === 'Code') {
            concept = predicatePartConceptDTO.cdsCodeDTO;
        } else if (conceptSelectionType === 'Concept') {
            concept = predicatePartConceptDTO.openCdsConceptDTO;
        }

        if (concept) {
            if (type === 'code') {
                concatenatedList += concept.code + comma;
            } else if (type === 'displayName') {
                concatenatedList += concept.displayName + comma;
            } else if (type === 'combo') {
                concatenatedList += concept.displayName + ' (' + concept.code + ')' + comma;
            }
        }
        counter++;
    }
    return concatenatedList;
}

export const PlainRender = ({ predicateType, part, ...props }) => {
    if (!part) return 'ERROR: part is null!';
    const partId = part?.partId ?? null;
    const partType = part?.partType ?? null;
    const partAlias = part?.partAlias ?? null;
    const text = part?.text ?? null;
    const criteriaResource = part?.criteriaResourceDTO ?? null;
    const resourceType = part?.resourceType ?? null;
    const criteriaResourceParamDTO = part?.criteriaResourceParamDTO ?? null;
    const dataInputNode = part?.dataInputNode ?? part?.dataInputNodeDTO ?? null;
    const dataInputClassType = part?.dataInputClassType ?? null;
    const predicatePartConcepts = part?.predicatePartConcepts ?? null;
    const dataInputBoolean = part?.dataInputBoolean ?? null;
    const dataInputDate1 = part?.dataInputDate1 ?? null;
    const dataInputDate2 = part?.dataInputDate2 ?? null;
    const defaultIdentifierRoot = part?.defaultIdentifierRoot ?? null;
    const defaultIdentifierExtension = part?.defaultIdentifierExtension ?? null;
    const dataInputNumeric = part?.dataInputNumeric ?? null;

    return (
        <PlainRenderContainer>
            {(() => {
                if (partAlias) {
                    if (predicateType === 'PredicateGroup') {
                        return <span className="predicate-group">{partAlias}</span>;
                    } else {
                        return partAlias;
                    }
                } else if (partType === 'Text') {
                    if (text) {
                        if (predicateType === 'PredicateGroup') {
                            return <span className="predicate-group">{text}</span>;
                        } else {
                            return text;
                        }
                    } else {
                        return '(Text is empty!)';
                    }
                } else if (partType === 'ModelElement') {
                    if (dataInputNode) {
                        return <>{dataInputNode.nodePath ? `[${dataInputNode.nodePath}]` : '(node path missing)'}</>;
                    } else {
                        return '(dataInputNode not selected!)';
                    }
                } else if (partType === 'Resource') {
                    if (criteriaResource && resourceType === 'Operator' && criteriaResourceParamDTO) {
                        return criteriaResourceParamDTO.name();
                    } else if (criteriaResource && !part?.functionEnd) {
                        return getResourceLabel(criteriaResource);
                    } else if (criteriaResource && part?.functionEnd) {
                        return '';
                    } else {
                        return '(criteriaResourceDTO not selected!)';
                    }
                } else if (partType === 'DataInput') {
                    // log.info(methodName + "part.predicatePartConcepts()=" + JSON.stringify(ko.toJS(part.predicatePartConcepts())));
                    if (dataInputClassType === 'Boolean') {
                        return dataInputBoolean;
                    } else if (dataInputClassType === 'Concept') {
                        if (predicatePartConcepts) {
                            return getConcatenatedConceptSelection(part, 'combo');
                        } else {
                            return 'No Items Selected';
                        }
                    } else if (dataInputClassType === 'Date') {
                        return dataInputDate1 || 'Date is not specified!';
                    } else if (dataInputClassType === 'DateRange') {
                        return `low - ${dataInputDate1 || 'unset'}; high - ${dataInputDate2 || 'unset'}`;
                    } else if (dataInputClassType === 'Identifier') {
                        return `root - ${defaultIdentifierRoot || 'unset'}; extension - ${defaultIdentifierExtension ||
                            'unset'}`;
                    } else if (dataInputClassType === 'Numeric') {
                        return dataInputNumeric || 'Number unset';
                    } else if (dataInputClassType === 'Quantity') {
                        return `qty - ${dataInputNumeric || 'unset'}; unit - ${text || 'unset'}`;
                    } else if (dataInputClassType === 'String') {
                        return text || 'String unset';
                    } else if (dataInputClassType === 'Eval') {
                        return text || 'Unset';
                    } else if (dataInputClassType === 'Keyword') {
                        return text || 'Unset';
                    } else {
                        return <pre>Unhandled dataInputClassType: {dataInputClassType}</pre>;
                    }
                } else {
                    return (
                        <pre>
                            Unsupported part type: {partType} - {partId}
                        </pre>
                    );
                }
            })()}
            {/* {typeof part.functionEnd !== 'undefined' && part.functionEnd ? ')' : null}
            {typeof part.parameterEnd !== 'undefined' && part.parameterEnd ? ', ' : null} */}
        </PlainRenderContainer>
    );
};

export default PlainRender;

PlainRender.propTypes = {
    ...ruleEditorViewPartCommonProps,
    part: PropTypes.object
};
